import { render } from "./AssistantEditor.vue?vue&type=template&id=a89c721e&scoped=true&ts=true"
import script from "./AssistantEditor.vue?vue&type=script&lang=ts"
export * from "./AssistantEditor.vue?vue&type=script&lang=ts"

import "./AssistantEditor.vue?vue&type=style&index=0&id=a89c721e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89c721e"]])

export default __exports__